import { ArrayDataSource } from './BaseDataSources';

export class CaptureLocationSource extends ArrayDataSource<{ key: string, value: string }> {
  public constructor() {
    super('componentapi/importschedule/capturelocations');
  }
}